import { domContentLoadEvent } from '../common/domContentLoadEvent';
import { closeModal, openModal } from '../common/simpleModal';

function initModalVideo() {
    //Open Modal
    document.querySelectorAll('.btn-play').forEach(function (item, k) {
        item.addEventListener('click', function (event) {
            const yid = event.currentTarget.getAttribute('data-yid');
            const legend = event.currentTarget.getAttribute('data-legend');

            document
                .querySelector('.modal-video iframe')
                .setAttribute('src', `https://www.youtube.com/embed/${yid}?rel=0`);

            document.querySelector('.modal-video p').innerHTML = legend;

            openModal('.modal-video');
        });
    });

    //Close Modal
    document.querySelector('.modal-video .close-modal').addEventListener('click', function () {
        document.querySelector('.modal-video iframe').setAttribute('src', 'about:blank');
        closeModal('.modal-video');
    });
}

domContentLoadEvent(initModalVideo);
